+((global, factory) => {
	//暂忽略AMD、CMD规范
	factory(document, global);
	const dev = process.env.NODE_ENV !== 'production'
	//  true
	//  process.env.NODE_ENV !== 'production'
})(window || this, (doc, context) => {
	class common {
		constructor() {
			this.remComputed();
			this.removeClass();
			this.findIndex();
			this.recordStatic();
			this.normalizeFontSize();
		}
		normalizeFontSize () {
			function handleFontSize() {
				WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
				WeixinJSBridge.on('menu:setfont', function() {
					WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
				})
			}
			if (
				typeof WeixinJSBridge == 'object' &&
				typeof WeixinJSBridge.invoke == 'function'
			) {
				handleFontSize();
			} else {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', handleFontSize);
					document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
				}
			}
		}
		// 记录uv/pv
		recordStatic () {
			// mui.ajax(domain + '/user/open/m/metricPage', { type: 'GET' })
		}
		/*
		 * @prototype {function} remComputed 动态改变root字号
		 * @returns {string} 
		 */
		remComputed() {
			let docEl = doc.documentElement,
				//屏幕改变兼容
				resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
				//屏幕改变事件
				recalc = () => {
					let clientWidth = docEl.clientWidth;
					if (!clientWidth) return;
					docEl.style.fontSize = 20 * (clientWidth / 360) + 'px';
					// 统计
					// (function() {
					// 	let _tjs = document.createElement("script");
					// 	_tjs.innerHTML = '!(function(c,b,d,a){c[a]||(c[a]={});c[a].config= { pid:"a1syv0xcxj@23ef4c1b0a5e212", appType:"web", imgUrl:"https://arms-retcode.aliyuncs.com/r.png?", sendResource:true, enableLinkTrace:true, behavior:true, enableConsole:true, useFmp:true, enableSPA:true }; with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d) })(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");'
					// 	let s = document.body; 
					// 	s.appendChild(_tjs);
					// })();
				};
			if (!doc.addEventListener) return;
			//屏幕尺寸改变触发事件
			context.addEventListener(resizeEvt, recalc, false);
			//DOM加载完成事件
			doc.addEventListener('DOMContentLoaded', recalc, false);
		}
		/**
		 * @prototype  {function} getImagePath获取指定大小的图片路径
		 * @param {string} 图片imgId 没有则为空，返回对应类型默认图片
		 * @param {string} type 图片类型，根据类型判断返回默认图片
		 * @param {string} 图片size 图片大小
		 * @returns {string} 返回合并后图片路径
		 */
		getImagePath(imgId, type, size) {
			// 获取图片域名
			let that = this,
				link;
			if (!imgId) return this.imagePath(type);
			// 获取图片前缀参数
			let prefix = JSON.parse(localStorage.getItem('imageprefix')) || {},
				count = prefix.count || 0,
				prefixDomain = prefix.data || '',
				prevDomain = prefix.domain || '';

			// 每获取100张图片或值不存在或域名更换时，重新获取prefix
			if ((count % 100 === 0 || !prefixDomain || prevDomain != domain)) {
				mui.ajax(domain + '/components/mediaservices/open/findImageProtocol.json', {
					type: 'GET',
					async: false,
					success: function(data) {
						if (!data.success) return context.common.imagePath(type);
						link = `${data.data}/${imgId}/${imgId}_${size}.jpg`;
						localStorage.setItem('imageprefix', JSON.stringify({
							data: data.data,
							count: 1, // 重新计数
							domain: domain
						}));
					},
					error: function(xhr, type, errorThrown) {
						console.log(type);
					}
				});
			} else {
				count++;
				link = `${prefixDomain}/${imgId}/${imgId}_${size}.jpg`;
				localStorage.setItem('imageprefix', JSON.stringify({
					data: prefixDomain,
					count: count,
					domain: domain
				}));
			}
			return link;
		}
		/**
		 * @prototype  {function} imagePath全局图片路径处理函数 
		 * @param {string} type 图片类型，根据类型判断返回默认图片
		 * @param {string} 图片Id 没有则为空，返回对应类型默认图片
		 * @param {string} 图片size 如果没有后缀返回没有后缀的地址，否则返回新地址
		 * @returns {string} 返回合并后图片路径
		 */
		imagePath(type, imgId, target, size) {
			if (!type) throw new Error('请输入图片类型');
			if (typeof imgId === 'string' && imgId) {
				if (size) {
					return context.common.getImagePath(imgId, type, size);
				} else {
					return `${domain}/api-file/mobile/open/file/stream/${imgId}?origin=true`
					//`${domain}/components/gtattachment/open/downloadAttachment.json?attachmentId=${imgId}`;
				}
			}

			let ratio = Math.round(window.devicePixelRatio);
			let defaultPath = "";
			if (ratio && ratio > 3) {
				ratio = 3
			}
			if (ratio) {
				defaultPath = "@" + ratio + "x";
			}
			if (imgId && Object.prototype.toString.call(imgId).indexOf('Event') > -1) {
				target = imgId;
				target.target.src = this.imagePath(type);
				target.target.onerror = null;
			}
			switch (type) {
				case 'class':
					return '../../../static/images/class-default' + defaultPath + '.png';
				case 'course':
					return '../../../static/images/course-default' + defaultPath + '.png';
				case 'information':
					return '../../../static/images/information-default' + defaultPath + '.png';
				case 'headImg':
					return '../../../static/images/headPhoto-default' + defaultPath + '.png';
				case 'teacher':
					return '../../../static/images/teacher-default' + defaultPath + '.png';
				case 'album':
					return '../../../static/images/album-default' + defaultPath + '.png';
				case 'zero':
					return '../../../static/images/zero' + defaultPath + '.jpg';
				case 'loading':
					return '../../../static/images/dx/loading-dx.png';
			}
		}
		/**
		 * @prototype  {function} audioPath全局语音路径处理函数 
		 * @param {string} 语音Id 没有则为空，返回对应类型默认图片
		 * @returns {string} 返回合并后语音路径
		 */
		audioPath(id) {
			return `${domain}/components/gtattachment/open/downloadAttachment.json?attachmentId=${id}`;
		}
		/*
		 * @prototype {function} netWorkState 获取当前网络状态,app专用
		 * @return {string} 网络状态
		 */
		netWorkState() {
			let NetStateStr = '未知';
			let types = {};
			if (mui.os.plus) {
				types[plus.networkinfo.CONNECTION_UNKNOW] = "未知";
				types[plus.networkinfo.CONNECTION_NONE] = "未连接网络";
				types[plus.networkinfo.CONNECTION_ETHERNET] = "有线网络";
				types[plus.networkinfo.CONNECTION_WIFI] = "WiFi网络";
				types[plus.networkinfo.CONNECTION_CELL2G] = "2G蜂窝网络";
				types[plus.networkinfo.CONNECTION_CELL3G] = "3G蜂窝网络";
				types[plus.networkinfo.CONNECTION_CELL4G] = "4G蜂窝网络";
				NetStateStr = types[plus.networkinfo.getCurrentType()];
			} else {
				NetStateStr = "有线网络";
			}
			return NetStateStr;
		}
		/*
		 * @prototype {function} openWindow 打开新窗口
		 * 
		 */
		openWindow(options) {
			var networkType = this.netWorkState();
			let hasHint = localStorage.getItem("nonetHint");
			if (networkType == "未知" || networkType == "未连接网络") {
				//未提示过则提示一次
				if (hasHint != 1 && options.url.indexOf('no-net') < 0) {
					localStorage.setItem("nonetHint", 1);
					options.url = '../../public/no-net/no-net.html'
					options.id = 'no-net'
				}
			} else {
				///再次有网,重置提醒
				if (hasHint == 1) {
					localStorage.setItem("nonetHint", 0);
				}
			}
			if (options.clearHistory) {
				window.location.replace(options.url);
				return;
			}

			function toQueryPair(key, value) {
				if (typeof value == 'undefined') {
					return key;
				}
				return key + '=' + encodeURIComponent(value === null ? '' : String(value));
			}

			function toQueryString(obj) {
				if (!obj) return new Date().getTime();
				var ret = [];
				for (var key in obj) {
					key = encodeURIComponent(key);
					var values = obj[key];
					if (values && values.constructor == Array) { //数组
						var queryValues = [];
						for (var i = 0, len = values.length, value; i < len; i++) {
							value = values[i];
							queryValues.push(toQueryPair(key, value));
						}
						ret = ret.concat(queryValues);
					} else { //字符串
						ret.push(toQueryPair(key, values));
					}
				}
				return ret.join('&');
			}
			if (options.autoShow !== false) {
				options.autoShow = true;
			}
			if (options.config) {
				if (!options.config.role) {
					options.role = localStorage.getItem("role") || "student";
				} else {
					options.role = options.config.role;
				}
				options.id = options.id || options.config.pageId;
				options.url = jurisdiction[options.config.pageSource][options.config.pageId][options.role] + "?" + toQueryString(
					options.config.params);
			}
			//权限控制
			new Promise((resolve, reject) => {
				//无权限
				if (!options.isPower) {
					resolve();
					return;
				}
				//查询登录权限
				mui.ajax({
					url: `${domain}/mobile/portal/1_1_0/findUserIsLogin.json`,
					methods: 'GET',
					success(res) {
						//登录成功
						if (res.data.data.isSuccess) {
							resolve()
							return
						}
						reject();
					},
					error() {
						reject();
					}
				})
			}).then(() => {
				mui.openWindow({
					url: options.url,
					id: options.id || options.config.pageId,
					styles: {
						scrollIndicator: "none",
						render: "always"
					},
					createNew: options.createNew || false,
					extras: options.extras || {},
					hardwareAccelerated: true,
					show: {
						autoShow: options.autoShow,
						aniShow: options.aniShow || "pop-in",
						event: 'titleUpdate',
					},
					waiting: {
						autoShow: true,
						title: options.title || '正在加载...'
					}
				})
			}, () => {
				this.openWindow({
					url: '../../login/app-login/login.html',
					id: 'login'
				})
			})
		}
		/**
		 * getUrlParam {function} 获取url
		 * @param {string} name 需要获取的参数名
		 * @returns {string} 返回参数值
		 */
		getUrlParam(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return r[2];
			return null;
		}
		/*
		 *初始化时间戳转换
		 *expand为拓展方法
		 *@num 时间戳
		 *@type 时间戳转换类型
		 */
		conversionFormat(num, type) {
			function _ConversionFormat(num, type) {
				if (!num) return '';
				this.tempTime = new Date(num);
				this.init();
				this.getTime = this.transform(type);
			}
			_ConversionFormat.prototype = {
				init: function() {
					this.time = {
						year: this.tempTime.getFullYear(),
						month: (this.tempTime.getMonth() + 1) < 10 ? (0 + '' + (this.tempTime.getMonth() + 1)) : this.tempTime.getMonth() +
							1,
						day: this.tempTime.getDate() < 10 ? (0 + '' + this.tempTime.getDate()) : this.tempTime.getDate(),
						hours: this.tempTime.getHours() < 10 ? 0 + '' + this.tempTime.getHours() : this.tempTime.getHours(),
						minutes: this.tempTime.getMinutes() < 10 ? 0 + '' + this.tempTime.getMinutes() : this.tempTime.getMinutes(),
						seconds: this.tempTime.getSeconds() < 10 ? 0 + '' + this.tempTime.getSeconds() : this.tempTime.getSeconds()
					}
				},
				transform: function(type) {
					switch (type) {
						case 'yyyy-MM-DD':
							return this.time.year + '-' + this.time.month + '-' + this.time.day;
						case 'yyyy/MM/DD':
							return this.time.year + '/' + this.time.month + '/' + this.time.day;
						case 'yyyy-MM':
							return this.time.year + '-' + this.time.month;
						case 'yyyy-MM-DD-hh-mm':
							return this.time.year + '-' + this.time.month + '-' + this.time.day + ' ' + this.time.hours + ':' + this.time
								.minutes;
						case 'yyyy-MM-DD-hh-mm-ss':
							return this.time.year + '-' + this.time.month + '-' + this.time.day + ' ' + this.time.hours + ':' + this.time
								.minutes + ':' + this.time.seconds;
						case 'MM-DD':
							return this.time.month + '-' + this.time.day;
						case 'MM-DD-hh-mm':
							return this.time.month + '-' + this.time.day + ' ' + this.time.hours + ':' + this.time.minutes;
						case 'hh-mm':
							return this.time.hours + ':' + this.time.minutes;
					}
				},
				expand: function() {
					return {
						year: this.time.year,
						month: this.time.month,
						day: this.time.day,
						hours: this.time.hours,
						minutes: this.time.minutes
					}
				}
			}
			return new _ConversionFormat(num, type);
		}
		/*
		 * @prototype {function} removeClass移除类名
		 */
		removeClass() {
			Element.prototype.removeClass = function(className) {
				let reg = new RegExp(className, 'g');
				this.className = this.className.replace(reg, '');
				return this;
			}
		}
		/*
		 * @prototype {function} 获取cookie
		 */
		cookies() {
			function getToken() {
				let cookie = plus.navigator.getCookie(domain)
				let cookList = cookie ? cookie.split(';') : []
				for (let item of cookList) {
					if (item.indexOf('XSRF-TOKEN') != -1) {
						return item.split('=')[1]
					}
				}
				return ''
			}
			return {
				get(key) {
					let token = ''
					let reg = new RegExp(`${key}=([^;]*)`)
					//判断当前运行环境
					if (mui.os.plus) {
						if (window.plus) return getToken()
						mui.plusReady(function() {
							token = getToken()
							localStorage.setItem('token', token)
						})
					}
					return document.cookie.match(reg) && document.cookie.match(reg)[1]
				},
				set(key, val, lifecycle) {
					let date = new Date()
					date.setTime(date.getTime() + (lifecycle * 24 * 60 * 60 * 1000))
					document.cookie = `${key}=${val};expires=${date.toUTCString()}`
				},
				remove(key) {
					this.set(key, '', -1)
				}
			}
		}
		/*
		 * @prototype {function} findIndex返回数组第一个满足条件的所有
		 */
		findIndex() {
			if (!Array.prototype.findIndex) {
				Object.defineProperty(Array.prototype, 'findIndex', {
					value: function(predicate) {
						if (this == null) {
							throw new TypeError('"this" is null or not defined');
						}
						var o = Object(this);
						// 将所有非数值转换为0，并数值取整
						var len = o.length >>> 0;
						if (typeof predicate !== 'function') {
							throw new TypeError('predicate must be a function');
						}
						// 需要执行的方法
						var thisArg = arguments[1];
						var k = 0;
						// 循环数组中的每个值调用指定方法，当满足条件时返回索引
						while (k < len) {
							var kValue = o[k];
							if (predicate.call(thisArg, kValue, k, o)) {
								return k;
							}
							k++;
						}
						return -1;
					}
				});
			}
		}
		/**
		 * 毫秒转换时分秒
		 */
		formatDuring(mss) {
			var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			if (hours < 10) {
				hours = "0" + hours;
			}
			var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
			if (minutes < 10) {
				minutes = "0" + minutes;
			}
			var seconds = (mss % (1000 * 60)) / 1000;
			if (seconds < 10) {
				seconds = "0" + seconds;
			}
			return hours + ":" + minutes + ":" + seconds;
		}
		/*
		 *字符长度修改
		 *@value 需要处理的字符串
		 *@maxlength 最大长度
		 *return {object}  时间戳转换类型
		 */
		lengthFilter(value, maxlength) {
			if (isNaN(maxlength - 0)) throw "no Number";
			value.toString();
			if (value.length >= maxlength) {
				return {
					value: value.slice(0, maxlength),
					overlength: 0
				};
			}
			return {
				value: value,
				overlength: maxlength - value.length
			};
		}
		/*
		 *输出日志
		 *@config 配置
		 *@state 该日志状态 success：成功  error：错误  defult：正常
		 *@cont 内容
		 *@isLine 是否添加分割线
		 *@source 来源   
		 * config{
		 * 	 DOMId 输出日志dom节点id，
		 *   filePath log日志文件位置，
		 *   isLog  是否输出日志(true|false)
		 * }
		 */
		log(config, state, cont, isLine, source) {
			function _log(config, state, cont, isLine, source) {
				this.init(cont);
				if (config && config.isLog) {
					this.htmlOutput(config.DOMId, state, isLine, source);
				}
			}
			_log.prototype = {
				init: function(cont) {
					let time = new Date().toLocaleDateString() + " " + new Date().toTimeString().slice(0, 8);
					this.cont = time + " -- " + cont;
				},
				htmlOutput: function(DOMId, state, isLine, source) {
					let htmlState = {
							success: "style=color:#419641",
							error: "style=color:#FF0000",
							defult: 'style=color:#000'
						},
						sourceState = {
							html: "style=background:#317ef3;color:#fff;padding: 0 10px",
							ajax: "style=background:#ae57a4;color:#fff;padding: 0 10px",
							plus: "style=background:#ffe66f;color:#fff;padding: 0 10px"
						},
						dom = document.getElementById(DOMId);
					isLine ? dom.innerHTML = dom.innerHTML + "<p>=================================</p>" : '';
					dom.innerHTML = dom.innerHTML + "<p " + htmlState[state] + "><span " + sourceState[source] + ">" + source +
						" </span>" + this.cont + "</p>";
				},
				fileOutput: function() {

				}
			}
			return new _log(config, state, cont, isLine, source);
		}
		/*
		 *角色解析
		 *@type 可传空或角色字符串
		 * return 空返回当前角色，角色字符串时返回是否与当前登录角色匹配
		 */
		getRole(type) {
			let roleMap = {
				'student': ['student'],
				'admin': ['admin'],
				'teacher': ['teacher', 'classManager']
			};
			let role = localStorage.getItem("role") || "student";
			if (type) {
				return type == role
			} else {
				for (let a in roleMap) {
					for (let i = 0, j = roleMap[a].length; i < j; i++) {
						if (roleMap[a][i] == role) {
							return a
						}
					}
				}
			}

		}
		/*
		 *访问统计
		 *@type Array klx,umeng
		 *@source  来源  APP WeChat PC
		 *@seat 位置  例：index,classes-list
		 */
		statistics(type, source, seat) {
			function _statistics(type, source, seat) {
				this.init(type, source);
			}
			_statistics.prototype = {
				init: function(type, source, seat) {
					let statisticsMap = {
						klx: this.klxStatistics,
						umeng: this.umengStatistics
					};
					for (let i = 0; i < type.length; i++) {
						statisticsMap[type[i]](source, seat);
					};
				},
				klxStatistics: function(source, seat) {
					// mui.ajax(domain + '/portal/indexPvNumber.json', {
					// 	data: {
					// 		clientType: source
					// 	},
					// 	type: 'get',
					// 	success: (res) => {

					// 	},
					// 	error: (res) => {

					// 	}
					// })
				},
				umengStatistics: function(source, seat) {
					var cnzz_protocol = (("https:" == document.location.protocol) ? " https://" : " http://");
					document.write(unescape("%3Cspan id='cnzz_stat_icon_1266351933'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol +
						"s22.cnzz.com/z_stat.php%3Fid%3D1266351933' type='text/javascript'%3E%3C/script%3E"));
					//百度统计
					//					var _hmt = _hmt || [];
					//					(function() {
					//					  var hm = document.createElement("script");
					//					  hm.src = "https://hm.baidu.com/hm.js?8293c08c02efd8744f82ab05d23b6e45";
					//					  var s = document.getElementsByTagName("script")[0]; 
					//					  s.parentNode.insertBefore(hm, s);
					//					})();
				}
			}
			return new _statistics(type, source, seat);
		}
		resourceImagePath(type) {
			if (!type) throw new Error('请输入图片类型');
			let ratio = Math.round(window.devicePixelRatio);
			let defaultPath = "";
			if (ratio && ratio > 3) {
				ratio = 3
			}
			if (ratio) {
				defaultPath = "@" + ratio + "x";
			}
			var obj = {};

			obj["xml"] = "xml";
			obj["zip"] = "zip";
			obj["doc"] = "doc";
			obj["docx"] = "doc";
			obj["txt"] = "txt";
			obj["vis"] = "vis";
			obj["rtf"] = "rtf";
			obj["pdf"] = "pdf";
			obj["ppt"] = "ppt";
			obj["pptx"] = "ppt";
			obj["psd"] = "psd";
			obj["mp4"] = "mp4";
			obj["mp3"] = "mp3";
			obj["img"] = "img";
			obj["jpg"] = "img";
			obj["png"] = "img";
			obj["bmp"] = "img";
			obj["gif"] = "img";
			obj["html"] = "html";
			obj["xls"] = "xls";
			obj["xlsx"] = "xls";
			let path = !mui.os.wechat ? '../../..' : domain + '/wechat';
			if (obj[type]) {
				return path + `/static/images/` + obj[type] + defaultPath + `.png`;
			} else {
				return path + `/static/images/att` + defaultPath + `.png`;
			}

		}
		fnTimeCountDown(d, o) {
			var f = {
				zero: function(n) {
					var n = parseInt(n, 10);
					if (n > 0) {
						if (n <= 9) {
							n = "0" + n;
						}
						return String(n);
					} else {
						return "00";
					}
				},
				dv: function() {
					d = d || Date.UTC(2050, 0, 1); //如果未定义时间，则我们设定倒计时日期是2050年1月1日
					var future = new Date(d),
						now = new Date();
					//现在将来秒差值
					var dur = Math.round((future.getTime() - now.getTime()) / 1000) + future.getTimezoneOffset() * 60,
						pms = {
							sec: "00",
							mini: "00",
							hour: "00",
							day: "00",
							month: "00",
							year: "0"
						};
					if (dur > 0) {
						pms.sec = f.zero(dur % 60);
						pms.mini = Math.floor((dur / 60)) > 0 ? f.zero(Math.floor((dur / 60)) % 60) : "00";
						pms.hour = Math.floor((dur / 3600)) > 0 ? f.zero(Math.floor((dur / 3600)) % 24) : "00";
						pms.day = Math.floor((dur / 86400)) > 0 ? f.zero(Math.floor((dur / 86400)) % 30) : "00";
					}
					return pms;
				},
				ui: function() {
					var day = f.dv().day;
					var hour = f.dv().hour;
					var mini = f.dv().mini;
					if (day != "00") {
						day = day.toString().replace(/(.)(?=[^$])/g, "$1,").split(",");
						o.bit.innerHTML = "天";
						if (day.length == 1) {
							o.ten.innerHTML = day[0];
							o.hundred.innerHTML = 0;
							o.thousand.innerHTML = 0;
						} else if (day.length == 2) {
							o.ten.innerHTML = day[0];
							o.hundred.innerHTML = day[1];
							o.thousand.innerHTML = 0;
						} else if (day.length == 3) {
							o.ten.innerHTML = day[0];
							o.hundred.innerHTML = day[1];
							o.thousand.innerHTML = day[2];
						}
					} else if (hour != "00") {
						hour = hour.toString().replace(/(.)(?=[^$])/g, "$1,").split(",");
						o.bit.innerHTML = "时";
						o.ten.innerHTML = "小";
						if (hour.length == 1) {
							o.thousand.innerHTML = hour[0];
							o.hundred.innerHTML = 0;
						} else if (hour.length == 2) {
							o.thousand.innerHTML = hour[0];
							o.hundred.innerHTML = hour[1];
						}
					} else if (mini != "00") {
						mini = mini.toString().replace(/(.)(?=[^$])/g, "$1,").split(",");
						o.bit.innerHTML = "钟";
						o.ten.innerHTML = "分";
						if (mini.length == 1) {
							o.thousand.innerHTML = mini[0];
							o.hundred.innerHTML = 0;
						} else if (mini.length == 2) {
							o.thousand.innerHTML = mini[0];
							o.hundred.innerHTML = mini[1];
						}
					} else {
						o.parent.classList.add("mui-hidden");
						document.querySelector(".going").classList.remove("mui-hidden");
					}
					setTimeout(f.ul, 1000);
				}
			};
			f.ui();
		}
		getBaseData(baseDataKeys) {
			let params = 'typeCodes=' + baseDataKeys.join('&typeCodes=')
			return new Promise((resolve, reject) => {
				mui.ajax({
					url: `${domain}/api-basic/workbench/dicttype/findDictList?` + params,
					methods: 'GET',
					success(res) {
						if (res.code == 2000) {
							let baseDataTypeMap = {}
							res.data.forEach(typeEle => {
								let baseDataMap = []
								typeEle.dicts.forEach(dataEle => {
									baseDataMap.push({
										value: dataEle.dictCode,
										text: dataEle.dictName
									})
									// baseDataMap[dataEle.dictCode] = dataEle.dictName
								})
								baseDataTypeMap[typeEle.dictTypeCode] = baseDataMap
							})
							resolve(baseDataTypeMap)
						} else {
							reject(res)
						}
					}
				})
			})
		}
	}
	context.common = new common;
	return common;
})
